import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EvaluationFormItemType } from "../models/due-diligence/evaluation-form-item-type.table";
import { ThirdPartyEvaluationFormItem } from "../models/thirdparty-evaluation-form-item";
import { FollowUpTaskFormItemDto, ThirdPartyFollowUpTaskFormItem } from "../models/thirdparty-tracing-tasks/thirdparty-tracing-task-external";
import { ValidateBlankSpaces } from "../views/pages/common/evaluation-score-page/customValidators/evaluation-customValidator";

export function createEvaluationForm(
    formItems: FollowUpTaskFormItemDto[],
    maxInputLength: number,
    maxCommentLength: number,
    minRequiredCommentLength,
    formLocked?: boolean,
    formAnswers?: ThirdPartyFollowUpTaskFormItem[]) {

    formLocked = formLocked || false;

    var form = {};
    for (const item of formItems) {
      /* #region Add-Validators */
      var validators = [];

      if (item.isRequired) {
        validators.push(Validators.required);
      }

      // Sólo para el caso del TextInput
      if (item.itemTypeId == EvaluationFormItemType.Text) {
        validators.push(Validators.maxLength(maxInputLength));
      }
      /* #endregion */

      var formItem: ThirdPartyFollowUpTaskFormItem;
      var answer: any;
      var answerComment: any;

      // Si es una pregunta de selección múltiple va a tener hijos
      if (item.itemTypeId == EvaluationFormItemType.MultipleDropDownSelection) {
        answer = [];
        //Busco todos los hijos respondidos de esta pregunta y obtengo sus respuestas
        var currentItemChildAnswers = formAnswers ? formAnswers.filter(x => x.followUpTaskFormItemId == item.id) : [];
        var currentItemChildAnswersIds = currentItemChildAnswers ? currentItemChildAnswers.map(x => x.answers[0].followUpTaskFormItemAnswerId as number) : [];

        for (const childId of currentItemChildAnswersIds) {
          // Obtengo el subitem que tiene ese childId
          var subItem = item.followUpTaskFormItemAnswers.find(y => {
            var subItem = y.id as ThirdPartyEvaluationFormItem;
            return subItem.appFormItemAnswers
              .map(x => x.id as number)
              .some(id => id == childId);
          }).id as ThirdPartyEvaluationFormItem;
          // Me quedo solamente con las selecciones que son True
          if (subItem.appFormItemAnswers.find(x => x.isTrue).id === childId) {
            answer.push(subItem)
          }
        }

        // Opción por defecto
        // 'ninguna opción elegida'
        if (!answer.length) {
          answer.push(Object.assign(new ThirdPartyEvaluationFormItem(), { id: null, isTrue: true }));
        }

        // Todas las subpreguntas deben tener el mismo comentario
        answerComment = currentItemChildAnswers.length > 0 ? currentItemChildAnswers[currentItemChildAnswers.length - 1].observation : '';
      }
      else {
        // Busco la pregunta correspondiente
        formItem = formAnswers ? formAnswers.find(x => x.followUpTaskFormItemId == item.id) : null;
        // Formateo de respuesta
        var customAnswer = item.itemTypeId == EvaluationFormItemType.Text ?
          (formItem ? formItem.inputText : null) :
          item.itemTypeId == EvaluationFormItemType.List ?
            (formItem ? formItem.inputTextList : null) :
            (formItem ? (formItem.answers && formItem.answers[0] && formItem.answers[0].followUpTaskFormItemAnswerId) : null);

        answer = customAnswer;
        answerComment = formItem ? formItem.observation : '';
      }

      // Reconstruyo la pregunta
      form[item.id] = [{ value: answer, disabled: formLocked }, validators]

      // Agrege control para comentario si está disponible
      if (item.isCommentAvailable) {
        form[`${item.id}-comment`] = [{ value: answerComment, disabled: formLocked }, Validators.maxLength(maxCommentLength)];
      }
    }

    const evaluationForm = new FormBuilder().group(form);

    // Getting Answer as single array[ThirdPartyEvaluationFormItemAnswer]
    const itemAnswers = [].concat.apply([], formItems.map(x => x.followUpTaskFormItemAnswers));

    // Check changes in form
    evaluationForm.valueChanges.subscribe({
      next: formValues => checkFormValues(formValues, itemAnswers, evaluationForm, maxCommentLength, minRequiredCommentLength)
    });

    checkFormValues(evaluationForm.getRawValue(), itemAnswers, evaluationForm, maxCommentLength, minRequiredCommentLength);

    return evaluationForm;
  }

export function checkFormValues(formValues: any, itemAnswers: any[], evaluationForm:FormGroup, maxCommentLength: number, minRequiredCommentLength: number) {
    const itemCodes = Object.getOwnPropertyNames(formValues).filter(x => !x.match(new RegExp('comment', 'gm')));

    for (let i = 0; i < itemCodes.length; i++) {
      const itemCode = itemCodes[i];
      const itemAnswerId = formValues[itemCode];

      const validators = [];
      validators.push(Validators.maxLength(maxCommentLength));

      const itemAnswer = itemAnswers.find(x => x.id == itemAnswerId);

      // Check for single answer
      if (itemAnswer != undefined && itemAnswer.isCommentRequired) {
        validators.push(Validators.required);
        validators.push(Validators.minLength(minRequiredCommentLength));
        validators.push(ValidateBlankSpaces);
      }
      // Check for multiple answer
      if (Array.isArray(itemAnswerId) && (typeof itemAnswerId[0] !== 'string')) {
        let multipleAnswers = itemAnswerId as ThirdPartyEvaluationFormItem[];

        // Ignore 'No selection' option
        if (multipleAnswers.every(x => x != null)) {
          let trueAnswers = [].concat.apply([], multipleAnswers.map(x => x.appFormItemAnswers));
          trueAnswers = trueAnswers.filter(x => x.isTrue);

          if (trueAnswers.some(x => x.isCommentRequired)) {
            validators.push(Validators.required);
            validators.push(Validators.minLength(minRequiredCommentLength));
            validators.push(ValidateBlankSpaces);
          }
        }
      }

      const commentControl = evaluationForm.get(`${itemCode}-comment`);
      if (commentControl) {
        commentControl.setValidators(validators);
        commentControl.updateValueAndValidity({ emitEvent: false });
        commentControl.markAsTouched({ onlySelf: true });
      }
    }
}